import styled from 'styled-components';

export const StyledLandingHeader = styled.div`
  width: 100%;
  z-index: 1;
  position: relative;

  .landing-header {
    width: 100%;
    height: ${(props) => (props.$variant === 'small' ? '300px' : '480px')};
    position: relative;

    &__bg {
      width: 100%;
      height: 100%;
      background-image: url(${({ $backgroundImage }) => $backgroundImage});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }

    &__content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      text-align: center;
      padding: 0 6%;
      padding-bottom: 80px;
      justify-content: flex-end;
      background: linear-gradient(
        270deg,
        ${({ theme }) => theme.colors.getTransparentColor(theme.colors.midnightNavy, 1)} 0%,
        ${({ theme }) => theme.colors.getTransparentColor(theme.colors.midnightNavy, 0.8)} 30%,
        transparent 64%
      );
    }

    &__hero {
      max-width: 520px;
    }

    &__hero-cta {
      display: flex;
      justify-content: center;
    }

    &__hero-title {
      margin-bottom: 16px;

      h1 {
        text-shadow: 0 2px 8px ${({ theme }) => theme.colors.getTransparentColor(theme.colors.black, 0.4)};
      }
    }

    &__hero-subtitle {
      margin-bottom: 28px;

      p {
        color: ${({ theme }) => theme.colors.getTransparentColor(theme.colors.white, 0.9)};
        text-shadow: 0 1px 4px ${({ theme }) => theme.colors.getTransparentColor(theme.colors.black, 0.3)};
      }
    }

    .gradient-button button {
      background: ${({ theme }) => theme.colors.mainOrange};
      border-color: ${({ theme }) => theme.colors.mainOrange};
      color: ${({ theme }) => theme.colors.white};
      padding: 14px 36px;

      &:hover {
        background: ${({ theme }) => theme.colors.white};
        border-color: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.mainOrange};
        background-position: 1% 50%;
      }
    }
  }

  @media (max-width: 1600px) {
    .landing-header {
      &__hero {
        max-width: 420px;
      }

      &__content {
        padding: 0 4%;
      }
    }
  }

  @media (max-width: 1200px) {
    .landing-header {
      &__hero {
        max-width: 380px;
      }

      &__content {
        padding: 0 32px;
      }
    }
  }

  @media (max-width: 1050px) {
    .landing-header {
      height: 300px;

      &__bg {
        background-image: url(${({ $mobileBackgroundImage }) => $mobileBackgroundImage});
        background-position: center;
      }

      &__content {
        display: none;
      }
    }
  }

  @media (max-width: 600px) {
    .landing-header {
      height: 260px;
    }
  }
`;
